import { render, staticRenderFns } from "./choseCourse.vue?vue&type=template&id=4b0eef87&scoped=true&"
import script from "./choseCourse.vue?vue&type=script&lang=js&"
export * from "./choseCourse.vue?vue&type=script&lang=js&"
import style0 from "./choseCourse.vue?vue&type=style&index=0&id=4b0eef87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0eef87",
  null
  
)

export default component.exports